import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { useLocation } from 'react-router';
import Home from './Home';
import Information from './Information';
import Projects from './Projects';
import Header from './Header';
import Footer from './Footer';

const Wrapper = ({ children }) => {
  const { pathname } = useLocation();

  return (<div className={pathname === '/information' ? 'company-intro' : ''}>
    {children}
  </div>)
}

function App() {
  return (
    <BrowserRouter>
      <Wrapper>
        <Header />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/information">
            <Information />
          </Route>
          <Route exact path="/projects/:id">
            <Projects />
          </Route>
        </Switch>
        <Footer />
      </Wrapper>
    </BrowserRouter>
  );
}

export default App;
